<div class="simulation__group">
    <p class="consents__introduction" [innerHTML]="(topSansSelectionMedicale ? 'consents.questionnaire.title.SSM' : 'consents.questionnaire.title') | i18n"></p>
</div>
<div class="grid-container">
    <div class="consents__figures grid-10 grid-mobile-4 no-gutter">
        <figure *ngIf="!topSansSelectionMedicale" class="consents__figure">
            <div class="consents__figureMedia consents__figureMedia--subscription"></div>
            <figcaption class="consents__figureCaption" [innerHTML]="'consents.questionnaire.text' | i18n"></figcaption>
        </figure>
        <figure *ngIf="topSansSelectionMedicale" class="consents__figure">
            <div class="consents__figureMedia consents__figureMedia--conduite"></div>
            <figcaption class="consents__figureCaption">
                <span>
                    {{ 'consents.advisor.h2.SSM' | i18n }}
                </span>
            </figcaption>
        </figure>
        <figure class="consents__figure">
            <div class="consents__figureMedia consents__figureMedia--declaration"></div>
            <figcaption *ngIf="!topSansSelectionMedicale" class="consents__figureCaption">
                <span>{{ 'consents.aeras.h2.pre' | i18n }}</span>
                <a id="convention-AERAS-dl-Link" (click)="downloadFile(conventionAERAS)" [routerLink]="" [innerHTML]="'consents.aeras.link_aeras.text' | i18n"> </a>
                <span [innerHTML]="'consents.aeras.h2.post' | i18n"></span>
            </figcaption>
            <figcaption *ngIf="topSansSelectionMedicale" class="consents__figureCaption">
                <span [innerHTML]="'consents.aeras.h2.SSM' | i18n"></span>
            </figcaption>
        </figure>
        <figure *ngIf="!topSansSelectionMedicale" class="consents__figure">
            <div class="consents__figureMedia consents__figureMedia--conduite"></div>
            <figcaption class="consents__figureCaption">
                <span>
                    {{ 'consents.advisor.h2' | i18n }}
                </span>
            </figcaption>
        </figure>
    </div>
</div>
<div class="simulation__group consents__warning">
    <p class="consents__information consents__warningText hide-mobile"><em class="icon--info"></em> {{ 'consents.questionnaire.information' | i18n }}</p>
    <p class="consents__information warning warning--light hide show-mobile">
        {{ 'consents.questionnaire.information' | i18n }}
    </p>
</div>
